import { render, staticRenderFns } from "./digitalCinema.vue?vue&type=template&id=6047bf4c&scoped=true&"
import script from "./digitalCinema.vue?vue&type=script&lang=js&"
export * from "./digitalCinema.vue?vue&type=script&lang=js&"
import style0 from "./digitalCinema.vue?vue&type=style&index=0&id=6047bf4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6047bf4c",
  null
  
)

export default component.exports